import { STORE_ORIGIN } from '../../config';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import CartIcon from '../CartIcon.jsx';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({
    main: null,
    category: null
  });
  const [navigation, setNavigation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const navbarRef = useRef(null);
  const dropdownTimeoutRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        closeAllDropdowns();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (dropdownTimeoutRef.current) {
        clearTimeout(dropdownTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const fetchNavigation = async () => {
      try {
        const response = await axios.get(`${STORE_ORIGIN}/api/test.php`);
        
        const formattedData = response.data.map(mainCategory => ({
          ...mainCategory,
          categories: mainCategory.categories.map(category => ({
            ...category,
            subcategories: category.subcategories || []
          }))
        }));

        setNavigation(formattedData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching navigation data:", err);
        
        // Fallback mock data
        setNavigation([
          {
            id: 1,
            name: "Boxing",
            categories: [
              {
                id: 1,
                name: "Gloves",
                subcategories: [
                  { id: 1, name: "Training Gloves" },
                  { id: 2, name: "Competition Gloves" }
                ]
              },
              {
                id: 2,
                name: "Protective Gear",
                subcategories: [
                  { id: 3, name: "Headgear" },
                  { id: 4, name: "Mouthguards" }
                ]
              }
            ]
          },
          {
            id: 2,
            name: "MMA",
            categories: [
              {
                id: 3,
                name: "Clothing",
                subcategories: [
                  { id: 5, name: "Shorts" },
                  { id: 6, name: "Rash Guards" }
                ]
              }
            ]
          }
        ]);
      }
    };

    fetchNavigation();
  }, []);

  const toggleDropdown = (level, id, e) => {
    e?.stopPropagation();
    setOpenDropdowns(prev => ({
      ...prev,
      [level]: prev[level] === id ? null : id
    }));
  };

  const handleMouseEnter = (level, id) => {
    // Clear any pending timeout to close dropdown
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
      dropdownTimeoutRef.current = null;
    }
    
    setOpenDropdowns(prev => ({
      ...prev,
      [level]: id
    }));
  };

  const handleMouseLeave = (level) => {
    // Set a timeout to close the dropdown after a delay
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    
    dropdownTimeoutRef.current = setTimeout(() => {
      setOpenDropdowns(prev => ({
        ...prev,
        [level]: null
      }));
    }, 300); // 300ms delay before closing
  };

  const closeAllDropdowns = () => {
    setOpenDropdowns({
      main: null,
      category: null
    });
    setIsMenuOpen(false);
  };

  if (loading) {
    return <div className="bg-gray-800 h-16"></div>;
  }

  return (
    <nav className="bg-gray-800 text-white shadow-lg relative z-50" ref={navbarRef}>
      {/* Top Bar */}
      {/* <div className="bg-gray-900 py-2 px-4 text-sm">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex space-x-4">
            <span className="text-gray-400">Free shipping on orders over QAR100</span>
            <Link to="/store-locator" className="text-red-400 hover:text-red-300">Store Locator</Link>
          </div>
          <div className="flex space-x-4">
            <Link to="/help" className="text-gray-400 hover:text-white">Help</Link>
            <Link to="/track-order" className="text-gray-400 hover:text-white">Track Order</Link>
          </div>
        </div>
      </div> */}

      {/* Main Navbar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center" onClick={closeAllDropdowns}>
              <img
                className="h-40 w-40 pt-5"
                src={logo}
                alt="Fight Gear Logo"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center">
            {/* Categories Dropdowns */}
            <div className="ml-6 flex space-x-1">
              {navigation.map(mainCategory => (
                <div 
                  key={mainCategory.id} 
                  className="relative"
                  onMouseEnter={() => handleMouseEnter('main', mainCategory.id)}
                  onMouseLeave={() => handleMouseLeave('main')}
                >
                  <div className="flex items-center">
                   <button
  type="button"
  className="px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700 text-white"
  onClick={(e) => {
    e.stopPropagation();
    toggleDropdown('main', mainCategory.id, e);
  }}
>
  {mainCategory.name}
</button>

                    {mainCategory.categories.length > 0 && (
                      <button
                        onClick={(e) => toggleDropdown('main', mainCategory.id, e)}
                        className="p-1 text-gray-400 hover:text-white focus:outline-none"
                      >
                        <svg
                          className={`h-4 w-4 transform ${openDropdowns.main === mainCategory.id ? 'rotate-180' : ''}`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {/* Main Category Dropdown */}
                  {openDropdowns.main === mainCategory.id && mainCategory.categories.length > 0 && (
                    <div 
                      className="absolute left-0 mt-0 w-56 rounded-md shadow-lg bg-gray-800 ring-1 ring-gray-700 z-50"
                      onMouseEnter={() => handleMouseEnter('main', mainCategory.id)}
                      onMouseLeave={() => handleMouseLeave('main')}
                    >
                      <div className="py-1">
                        {mainCategory.categories.map(category => (
                          <div 
                            key={category.id} 
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('category', category.id)}
                            onMouseLeave={() => handleMouseLeave('category')}
                          >
                            <div className="flex justify-between items-center px-4 py-2 hover:bg-gray-700">
                              <Link
                                to={`/${mainCategory.slug}/${category.slug}`}
                                className="text-sm text-gray-300 hover:text-white block w-full text-left"
                                onClick={closeAllDropdowns}
                              >
                                {category.name}
                              </Link>
                              {category.subcategories.length > 0 && (
                                <button
                                  onClick={(e) => toggleDropdown('category', category.id, e)}
                                  className="p-1 text-gray-400 hover:text-white focus:outline-none"
                                >
                                  <svg
                                    className={`h-4 w-4 transform ${openDropdowns.category === category.id ? 'rotate-180' : ''}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              )}
                            </div>

                            {/* Subcategory Dropdown */}
                            {openDropdowns.category === category.id && category.subcategories.length > 0 && (
                              <div 
                                className="absolute left-full top-0 ml-1 w-56 rounded-md shadow-lg bg-gray-800 ring-1 ring-gray-700 z-50"
                                onMouseEnter={() => handleMouseEnter('category', category.id)}
                                onMouseLeave={() => handleMouseLeave('category')}
                              >
                                {category.subcategories.map(subcategory => (
                                  <Link
                                    key={subcategory.id}
                                    to={`/${mainCategory.slug}/${category.slug}/${subcategory.slug}`}

                                    className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                                    onClick={closeAllDropdowns}
                                  >
                                    {subcategory.name}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Search Bar */}
            <div className="ml-4 relative">
              <div className="flex items-center">
                <input
                  type="text"
                  placeholder="Search products..."
                  className="px-3 py-1.5 rounded-l-md text-sm bg-gray-700 text-white focus:outline-none focus:ring-1 focus:ring-red-500 w-48"
                />
                <button className="bg-red-600 hover:bg-red-700 px-3 py-1.5 rounded-r-md">
                  <svg
                    className="h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Icons */}
            <div className="ml-4 flex items-center space-x-4">
              <Link
                to="#"
                className="p-2 rounded-full hover:bg-gray-700"
                title="Account"
                onClick={closeAllDropdowns}
              >
                <svg
                  className="h-5 w-5 text-gray-300"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </Link>

              <Link
                to="#"
                className="p-2 rounded-full hover:bg-gray-700"
                title="Wishlist"
                onClick={closeAllDropdowns}
              >
                <svg
                  className="h-5 w-5 text-gray-300"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  />
                </svg>
              </Link>

              {/* Replaced the hardcoded cart icon with the CartIcon component */}
              <CartIcon className="p-2 rounded-full" onClick={closeAllDropdowns} />
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-gray-800 z-50">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {/* Mobile Search */}
            <div className="px-3 py-2">
              <div className="flex">
                <input
                  type="text"
                  placeholder="Search..."
                  className="px-3 py-2 rounded-l-md text-sm bg-gray-700 text-white focus:outline-none w-full"
                />
                <button className="bg-red-600 hover:bg-red-700 px-3 py-2 rounded-r-md">
                  <svg
                    className="h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Mobile Categories */}
            {navigation.map(mainCategory => (
              <div key={mainCategory.id} className="px-3 py-2">
                <div className="flex justify-between items-center">
                  <button
  type="button"
  className="text-white hover:bg-gray-700 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
  onClick={(e) => {
    e.stopPropagation();
    toggleDropdown('main', mainCategory.id, e);
  }}
>
  {mainCategory.name}
</button>

                  {mainCategory.categories.length > 0 && (
                    <button
                      onClick={(e) => toggleDropdown('main', mainCategory.id, e)}
                      className="text-gray-400 hover:text-white p-1"
                    >
                      <svg
                        className={`h-5 w-5 transform ${openDropdowns.main === mainCategory.id ? 'rotate-180' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  )}
                </div>

                {/* Mobile Category Dropdown */}
                {openDropdowns.main === mainCategory.id && mainCategory.categories.length > 0 && (
                  <div className="mt-2 pl-4">
                    {mainCategory.categories.map(category => (
                      <div key={category.id} className="mb-2">
                        <div className="flex justify-between items-center">
                          <Link
                              to={`/${mainCategory.slug}/${category.slug}`}
                              className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-sm font-medium"
                              onClick={closeAllDropdowns}
                            >
                              {category.name}
                            </Link>

                          {category.subcategories.length > 0 && (
                            <button
                              onClick={(e) => toggleDropdown('category', category.id, e)}
                              className="text-gray-400 hover:text-white p-1"
                            >
                              <svg
                                className={`h-4 w-4 transform ${openDropdowns.category === category.id ? 'rotate-180' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          )}
                        </div>

                        {/* Mobile Subcategory Dropdown */}
                        {openDropdowns.category === category.id && category.subcategories.length > 0 && (
                          <div className="mt-1 pl-4">
                            {category.subcategories.map(subcategory => (
                              <Link
                                  key={subcategory.id}
                                  to={`/${mainCategory.slug}/${category.slug}/${subcategory.slug}`}
                                  className="block px-3 py-2 text-sm text-gray-400 hover:text-white"
                                  onClick={closeAllDropdowns}
                                >
                                  {subcategory.name}
                                </Link>

                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {/* Mobile Account Links */}
            <div className="pt-4 pb-2 border-t border-gray-700">
              <div className="flex items-center px-3 py-2">
                <div className="flex-shrink-0">
                  <svg
                    className="h-6 w-6 text-gray-300"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <div className="text-sm font-medium text-white">Account</div>
                </div>
              </div>
              <div className="mt-2 pl-12 space-y-1">
                <Link
                  to="/account"
                  className="block px-3 py-2 text-sm text-gray-300 hover:text-white"
                  onClick={closeAllDropdowns}
                >
                  Profile
                </Link>
                <Link
                  to="/wishlist"
                  className="block px-3 py-2 text-sm text-gray-300 hover:text-white"
                  onClick={closeAllDropdowns}
                >
                  Wishlist
                </Link>
                {/* Added CartIcon to mobile menu */}
                <div className="block px-3 py-2">
                  <CartIcon onClick={closeAllDropdowns} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;